<template>
  <div :class="['container', $style.container]">
    <div :class="$style.customPlan">
      <div :class="$style.wrapper">
        <UiIconsCustomPlan />
        <div :class="$style.content">
          <div :class="$style.title">Custom</div>
          <div :class="$style.caption">{{ t('prices.custom.text') }}</div>
        </div>
      </div>
      <UiButton 
        to="https://t.me/zerodetect_support" blank
        :class="$style.action"
      >
        <template #label>
          {{ t('prices.custom.button') }}
        </template>
        <template #preppendIcon>
          <UiIconsArrowTopRight />
        </template>
      </UiButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
</script>

<style lang="scss" module>
.customPlan {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 20px 12px;
  border-radius: 8px;
  border: 1px solid #EAEAEA;
  margin: 28px 0;

  @media (max-width: 1023px) {
    flex-direction: column;
  }

  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 640px;

    .title {
      font-size: 24px;
      color: #121E29;
    }

    .caption {
      color: #596269;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
    }
  }

  svg {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
  }

  .action {
    margin-left: auto;

    @media (max-width: 1023px) {
      margin: 0 auto;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
}
</style>